import { Router } from '@angular/router';
import { clearAllPortalStorage } from './portal-auth-storage';
import { PortalTokenStore } from './portal-token.store';
import { PortalAuthApi } from './portal-auth.api';

export async function logoutPortalUser(
  router: Router,
  doc: Document,
  portalTokenStore: PortalTokenStore,
  authApi?: PortalAuthApi
): Promise<void> {
  clearAllPortalStorage(doc);

  const refreshToken = portalTokenStore.getRefreshToken();
  if (refreshToken && authApi) {
    try {
      await authApi.signOut(refreshToken);
    } catch {
      // Best-effort server-side revocation
    }
  }

  portalTokenStore.clearTokens();
  void router.navigate(['/signin']);
}
